import { Text } from '$components'
import { ReactNode } from 'react'

export type TextCellProps = {
  children: ReactNode
}

export function TextCell({ children }: TextCellProps) {
  return (
    <Text
      type="s"
      className="text-nowrap"
    >
      {children}
    </Text>
  )
}
